import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import CibilReportPdfOutputComponent from '../output/CibilReportPdfOutputComponent';

const GENDERS = [
    { label: 'Male', value: 'male' },
    { label: 'Female', value: 'female' },
];

const CibilReportPdfInputComponent = () => (
    <SimpleReportForm
        banner={{ icon: 'pi-file-pdf', title: 'CIBIL Credit Report (PDF)', subtitle: 'Fetch CIBIL credit report as a downloadable PDF' }}
        fields={[
            { name: 'mobile', label: 'Mobile Number', icon: 'pi-phone', placeholder: '9876543210', maxLength: 10, inputMode: 'tel', numeric: true, mono: true,
              regex: /^[6-9]\d{9}$/, regexError: 'Enter a valid 10-digit Indian mobile' },
            { name: 'pan', label: 'PAN Number', icon: 'pi-id-card', placeholder: 'ABCDE1234F', maxLength: 10, autoCapitalize: 'characters', spellCheck: false, uppercase: true, mono: true,
              regex: /^[A-Z]{5}\d{4}[A-Z]$/, regexError: 'Invalid PAN format' },
            { name: 'name', label: 'Full Name', icon: 'pi-user', placeholder: 'Enter full name', maxLength: 100, autoCapitalize: 'words' },
            { name: 'gender', label: 'Gender', type: 'dropdown', options: GENDERS, placeholder: 'Select gender', colClass: 'col-12 md:col-6 lg:col-3' },
        ]}
        endpoint={{
            path: '/surepass/credit-report-cibil/fetch-report-pdf',
            bodyMapper: (v, sid) => ({ mobile: v.mobile, pan: v.pan, name: v.name.trim(), gender: v.gender, consent: v.consent ? 'Y' : 'N', api_provider_service_id: parseInt(sid, 10) }),
        }}
        consentReportType="cibil-report-pdf"
        submitLabel="Fetch CIBIL PDF"
        successSummary="CIBIL PDF fetched"
        errorSummary="CIBIL PDF failed"
        confirmHeader="Confirm CIBIL PDF fetch"
        confirmAcceptLabel="Yes, fetch"
        outputComponent={CibilReportPdfOutputComponent}
    />
);

export default CibilReportPdfInputComponent;
